import '../Tutorial.css';

import React from 'react';
import TutorialGirl from "../TutorialGirl";
import Typewriter from "typewriter-effect";


function T95ClickOffers() {

    /*
  useEffect(() => {
    UserService.sendEvent('MenuResearch90');
  }, []);
 */

  const text = 'For the next adventures, you\'ll need new powerful cards. You can find them by clicking on the \'Offers\' icon.';

    return (
        <div>

            <div className={'T95Top'}></div>

            <TutorialGirl undressingProcess={3}/>
            <div className='tutorialContainer tutorialTopContainer95'>
                <div className='tutorialBottomTextField'><Typewriter
                    options={{
                        delay: 30
                    }}
                    onInit={(typewriter) => {
                        typewriter.typeString(text).start();
                    }}
                /></div>
            </div>
        </div>

    );
}

export default T95ClickOffers;
